import { fmtAbsolute, fmtDuration, basename } from "../lib/format";
import { Clock, FileCode2 } from "lucide-react";

export default function SessionsList({ sessions, onSelect }) {
  if (!sessions?.length) {
    return (
      <div className="trace-card p-6 text-sm text-[#6b7280]" data-testid="sessions-empty">
        No prior sessions yet.
      </div>
    );
  }
  return (
    <ul className="space-y-3" data-testid="sessions-list">
      {sessions.map((s) => (
        <li
          key={s.id}
          data-testid={`session-row-${s.id}`}
          onClick={() => onSelect?.(s)}
          className="group cursor-pointer trace-card p-5 hover:-translate-y-0.5 hover:shadow-md transition-all duration-300"
        >
          <div className="flex items-center justify-between gap-3">
            <div className="flex items-center gap-3">
              <div className="w-1.5 self-stretch rounded-full bg-gradient-to-b from-blue-500 to-indigo-500 opacity-70 group-hover:opacity-100 transition" />
              <div>
                <div className="text-sm text-[#111827] leading-tight">
                  {s.session_note || s.summary}
                </div>
                <div className="text-[11px] text-[#6b7280] mt-1 font-mono">
                  {fmtAbsolute(s.start_time)} → {fmtAbsolute(s.end_time)}
                </div>
              </div>
            </div>
            <div className="flex items-center gap-4 text-xs text-[#6b7280] shrink-0">
              <span className="flex items-center gap-1">
                <Clock size={12} /> {fmtDuration(s.duration_seconds)}
              </span>
              <span className="flex items-center gap-1">
                <FileCode2 size={12} /> {s.files_touched_count}
              </span>
            </div>
          </div>
          {s.files_touched?.length > 0 && (
            <div className="mt-3 flex flex-wrap gap-1.5">
              {s.files_touched.slice(0, 5).map((f) => (
                <span
                  key={f}
                  className="font-mono text-[10px] px-2 py-0.5 rounded bg-white border border-[#e5e7eb] text-[#374151]"
                >
                  {basename(f)}
                </span>
              ))}
              {s.files_touched.length > 5 && (
                <span className="text-[10px] text-[#9ca3af]">+{s.files_touched.length - 5}</span>
              )}
            </div>
          )}
        </li>
      ))}
    </ul>
  );
}
